import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
let baseUrl2 = `${httpUrl.host}/gy-apartment`

let api = {
  // 查询园区基本数据
  getParkBaseInfo: `${baseUrl}/park/baseInfo/getParkBaseInfo`,

  // 修改园区基本数据
  updateParkBaseInfo: `${baseUrl}/park/baseInfo/update`,

  // 园区产值税收
  getParkFinancePage: `${baseUrl}/parkFinance/getPage`,

  // 添加园区产值税收
  addParkFinance: `${baseUrl}/parkFinance/add`,

  // 删除园区产值税收
  deleteParkFinanceByCodes: `${baseUrl}/parkFinance/deleteByCodes`,

  // 添加园区荣誉
  addParkHonor: `${baseUrl}/park/honor/add`,

  // 修改园区荣誉
  updateParkHonor: `${baseUrl}/park/honor/update`,

  // 删除园区荣誉
  deleteParkHonorByCodes: `${baseUrl}/park/honor/deleteByCodes`,

  // 园区荣誉分页
  getParkHonorPage: `${baseUrl}/park/honor/getPage`,

  // 园区荣誉详情
  getParkHonorByCode: `${baseUrl}/park/honor/getByCode`,

  // 添加园区企业培育
  addEnterpriseDevelop: `${baseUrl}/park/enterpriseDevelop/add`,

  // 修改园区企业培育
  updateEnterpriseDevelop: `${baseUrl}/park/enterpriseDevelop/update`,

  // 删除园区企业培育
  deleteEnterpriseDevelopByCodes: `${baseUrl}/park/enterpriseDevelop/deleteByCodes`,

  // 园区企业培育分页
  getEnterpriseDevelopPage: `${baseUrl}/park/enterpriseDevelop/getPage`,

  // 园区企业培育详情
  getEnterpriseDevelopByCode: `${baseUrl}/park/enterpriseDevelop/getByCode`,

  // 添加高端要素
  addParkHighEnd: `${baseUrl}/park/highEnd/add`,

  // 修改高端要素
  updateParkHighEnd: `${baseUrl}/park/highEnd/update`,

  // 删除高端要素
  deleteParkHighEndByCodes: `${baseUrl}/park/highEnd/deleteByCodes`,

  // 高端要素分页
  getParkHighEndPage: `${baseUrl}/park/highEnd/getPage`,

  // 高端要素详情
  getParkHighEndByCode: `${baseUrl}/park/highEnd/getByCode`,

  // 上传图片
  uploadImg: `${baseUrl2}/yqNews/uploadImg`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/DataServicePark.js